/**
 * 같은 origin(Pages/dev)에서 정적 파일 /05_lotto_numbers.js 를 받아 파싱.
 * - 줄바꿈/포맷 흔들림에 견고하도록 LOTTO_NUMBERS 배열 안의 모든 숫자를 평면 추출 후 6개씩 chunk.
 * - 매주 사용자가 web/public/05_lotto_numbers.js 파일을 직접 편집 → git push → Pages 자동 재배포.
 */
export async function fetchLottoData() {
  const res = await fetch("/05_lotto_numbers.js", { cache: "no-cache" });
  if (!res.ok) throw new Error(`fetch /05_lotto_numbers.js ${res.status}`);
  const text = await res.text();

  const m = text.match(/LOTTO_NUMBERS\s*=\s*\[([\s\S]*?)\];/);
  if (!m) throw new Error("LOTTO_NUMBERS array not found");
  const flat = (m[1].match(/\d+/g) || []).map(Number);
  if (flat.length === 0 || flat.length % 6 !== 0) {
    throw new Error(`invalid number count: ${flat.length}`);
  }
  const bad = flat.find((n) => n < 1 || n > 45);
  if (bad !== undefined) throw new Error(`invalid lotto number: ${bad}`);

  const rows = [];
  for (let i = 0; i < flat.length; i += 6) {
    rows.push(flat.slice(i, i + 6).join(","));
  }
  return { lastDraw: rows.length, rows };
}
